/*
  Collection page price filter: the slider in the faceted sidebar (snippets/sidebar__faceted-filter.liquid).
  Loaded only on collection/search pages, after nouislider.min.js and wNumb.min.js (layout/theme.liquid).
  Shoppers see the two labels, the slider and Apply; the two number boxes the form submits are hidden by
  custom.css (.priceRangeAreaList .faceted-filter-group-display__price-range).

  PBM 2026-10-12 rewrite of the original slider code (same markup, same look). It fixes:
  - a crash on collections whose dearest product is under $1: the old code built the slider range from a 1..max
    array, got 0..0, and noUiSlider threw "'range' 'min' and 'max' cannot be equal" (/collections/on-sale);
  - the top of the slider rounding DOWN, so Apply dropped the dearest product (/collections/masimo: $7,429.50
    became lte=7429 and masimo-3736 disappeared). The track now runs to the next whole dollar, the top label shows
    the exact top price, and a lower bound is never written above it;
  - an applied price range being ignored: the slider always started at 0..top. Now the labels show the exact
    applied bounds and each handle starts where it can be dragged to its end to clear its bound;
  - the boxes being rewritten on every page load, which sent a full-range price filter with every brand or type
    click (the "$0.00 - $14,600.00" chip). Now only the handle the shopper moves writes its own box, and a handle
    left at its end leaves its box empty, so that bound is not sent;
  - a 1..max array (14,600 numbers on /collections/all) built and logged to the console on every page load.
  No jQuery needed.
*/
(function () {
  'use strict';

  function toNumber(v) {
    var n = parseFloat(v);
    return isFinite(n) ? n : null;
  }

  function init() {
    var slider = document.getElementById('priceRangeSlider');
    var minBox = document.getElementById('minProdVal');
    var maxBox = document.getElementById('maxProdVal');
    if (!slider || !minBox || !maxBox || slider.noUiSlider) return;
    if (typeof window.noUiSlider === 'undefined' || typeof window.wNumb === 'undefined') return;

    var exactTop = toNumber(maxBox.getAttribute('max'));
    var top = Math.max(1, Math.ceil(exactTop || 0));
    var from = toNumber(minBox.value);
    var to = toNumber(maxBox.value);
    // Handles start on the safe side of an applied bound (from rounds up, to rounds down), so each can always be
    // dragged to its end to clear it. The labels show the exact bound.
    var low = from === null ? 0 : Math.min(Math.max(Math.ceil(from), 0), top);
    var high = to === null ? top : Math.min(Math.max(Math.floor(to), low), top);
    var money = window.wNumb({ decimals: 0, thousand: ',', prefix: '$' });
    var cents = window.wNumb({ decimals: 2, thousand: ',', prefix: '$' });
    function label(v) { return (Math.round(v * 100) % 100 === 0 ? money : cents).to(v); }
    var topLabel = label(exactTop !== null ? exactTop : top);
    var labels = [document.getElementById('slider-value-min'), document.getElementById('slider-value-max')];
    function paint() {
      var a = toNumber(minBox.value);
      var b = toNumber(maxBox.value);
      if (labels[0]) labels[0].innerHTML = label(a === null ? 0 : a);
      if (labels[1]) labels[1].innerHTML = b === null ? topLabel : label(b);
      // An empty box is left out of the submitted URL altogether (disabled fields are not sent).
      minBox.disabled = a === null;
      maxBox.disabled = b === null;
    }

    window.noUiSlider.create(slider, {
      start: [low, high],
      step: 1,
      range: { min: 0, max: top },
      format: money,
      connect: true
    });
    paint();

    // 'slide' fires only for a shopper's drag or tap, with the handle that moved (0 = from, 1 = to).
    slider.noUiSlider.on('slide', function (values, handle) {
      var v = money.from(values[handle]);
      if (handle === 0) {
        minBox.value = v > 0 ? (exactTop !== null ? Math.min(v, exactTop) : v) : '';
      } else {
        maxBox.value = v < top ? v : '';
      }
      paint();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
